import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard } from '~/core/PermissionGuard';
import { ValleyBankPermissionsFn } from '~/core/routes/valley-bank/types';
import { useSimpleConfirm } from '~/packages/common-frontend/hooks/useSimpleConfirm';
import { Assignment } from '~/valleyBank/domains/Assignment/ui/Assignment';
import { useDataMetadataContext } from '~/valleyBank/domains/page/hooks/DataMetadataContext';
import { useUserRoleTypePermissionsContext } from '~/valleyBank/domains/page/hooks/useUserRoleTypePermissions';

// Fragments
const RouteBase = () => {
  // !TODO @eldarshamukhamedov react-router@6: This needs to be replaced with unstable_usePrompt as
  // soon as we switch to a data router.
  useSimpleConfirm({
    when: true,
    message:
      'Are you sure you want to leave this page? Any changes not submitted to the queue will be lost.',
  });

  return <Assignment />;
};

// Exports
export const valleyPermissions: ValleyBankPermissionsFn = (context) => {
  if (context.dashboardMode !== 'current') return 'deny';
  if (!context.permissions?.assignmentQueueRead) return 'deny';
  return 'allow';
};
export const Route = () => {
  const { dashboardMode } = useDataMetadataContext();
  const { permissions } = useUserRoleTypePermissionsContext();
  return (
    <PermissionGuard
      permissions={() => valleyPermissions({ dashboardMode, permissions })}
      fallback={<Navigate to="./loan-accounts" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="./loan-accounts" />;
        }}
      >
        <RouteBase />
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
